import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { UUID } from 'crypto';
import { handleGlobalSearch } from '@/utils';

export const partnersApi = createApi({
	reducerPath: 'partnersApi',
	tagTypes: ['partners', 'selectedPartner'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getAllPartners: builder.query({
			query: () => ({
				url: `partners/all`,
			}),
			providesTags: ['partners'],
		}),
		getPartners: builder.query({
			query: ({ page, filters }: { page: number; filters: any }) => ({
				url: `partners`,
				params: { page, ...handleGlobalSearch(filters, ['name']) },
			}),
			providesTags: ['partners'],
		}),

		getPartnerById: builder.query({
			query: (id: UUID) => ({
				url: `partners/${id}`,
			}),
			providesTags: ['partners'],
		}),
		deletePartner: builder.mutation({
			query: (id: UUID) => ({
				url: `partners/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['partners'],
		}),
		addPartner: builder.mutation({
			query: ({ name }: { name: string }) => ({
				url: `partners`,
				method: 'POST',
				body: { name },
			}),
			invalidatesTags: ['partners'],
		}),
		updatePartner: builder.mutation({
			query: ({ name, id }: { name: string; id: UUID }) => ({
				url: `partners/${id}`,
				method: 'PATCH',
				body: { name },
			}),
			invalidatesTags: ['partners'],
		}),
		uploadLogo: builder.mutation({
			query: ({ id, body }) => ({
				url: `partners/${id}/logo`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['partners'],
		}),

		uploadRegistersTemplate: builder.mutation({
			query: ({ id, body }) => ({
				url: `partners/${id}/upload-template`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['selectedPartner'],
		}),
		resetPreRegisters: builder.mutation({
			query: ({ id, body }) => ({
				url: `partners/${id}/reset-pre-register`,
				method: 'DELETE',
			}),
			invalidatesTags: ['selectedPartner'],
		}),
		getAllPartnerAttendees: builder.query({
			query: ({ id, page, filters }: { id: string; page: number; filters: any }) => ({
				url: `partners/${id}/all-attendees`,
				params: { page, ...handleGlobalSearch(filters, ['name']) },
			}),
			providesTags: ['selectedPartner'],
		}),
		getPartnerStatistics: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `partners/${id}/statistics`,
			}),
		}),
	}),
});

export const {
	useResetPreRegistersMutation,
	useUploadRegistersTemplateMutation,
	useAddPartnerMutation,
	useDeletePartnerMutation,
	useGetAllPartnersQuery,
	useGetPartnersQuery,
	useUpdatePartnerMutation,
	useUploadLogoMutation,
	useGetPartnerByIdQuery,
	useGetAllPartnerAttendeesQuery,
	useGetPartnerStatisticsQuery,
} = partnersApi;
